window.VH = window.VH === undefined ? {} : window.VH;

VH.WebSpeech = {
    recognition : null,
    iconOn : '<i class="fas fa-microphone text-success animate__animated animate__flash animate__infinite"></i>',
    iconOff : '<i class="fas fa-microphone text-danger"></i>',
    langs : [
        ['Afrikaans',       ['af-ZA']],
        ['Bahasa Indonesia',['id-ID']],
        ['Bahasa Melayu',   ['ms-MY']],
        ['Català',          ['ca-ES']],
        ['Čeština',         ['cs-CZ']],
        ['Deutsch',         ['de-DE']],
        ['English',
            ['en-AU', 'Australia'],
            ['en-CA', 'Canada'],
            ['en-IN', 'India'],
            ['en-NZ', 'New Zealand'],
            ['en-ZA', 'South Africa'],
            ['en-GB', 'United Kingdom'],
            ['en-US', 'United States']
        ],
        ['Español',
            ['es-AR', 'Argentina'],
            ['es-BO', 'Bolivia'],
            ['es-CL', 'Chile'],
            ['es-CO', 'Colombia'],
            ['es-CR', 'Costa Rica'],
            ['es-EC', 'Ecuador'],
            ['es-SV', 'El Salvador'],
            ['es-ES', 'España'],
            ['es-US', 'Estados Unidos'],
            ['es-GT', 'Guatemala'],
            ['es-HN', 'Honduras'],
            ['es-MX', 'México'],
            ['es-NI', 'Nicaragua'],
            ['es-PA', 'Panamá'],
            ['es-PY', 'Paraguay'],
            ['es-PE', 'Perú'],
            ['es-PR', 'Puerto Rico'],
            ['es-DO', 'República Dominicana'],
            ['es-UY', 'Uruguay'],
            ['es-VE', 'Venezuela']
        ],
        ['Euskara',         ['eu-ES']],
        ['Français',        ['fr-FR']],
        ['Galego',          ['gl-ES']],
        ['Hrvatski',        ['hr_HR']],
        ['IsiZulu',         ['zu-ZA']],
        ['Íslenska',        ['is-IS']],
        ['Italiano',
            ['it-IT', 'Italia'],
            ['it-CH', 'Svizzera']
        ],
        ['Magyar',          ['hu-HU']],
        ['Nederlands',      ['nl-NL']],
        ['Norsk bokmål',    ['nb-NO']],
        ['Polski',          ['pl-PL']],
        ['Português',
            ['pt-BR', 'Brasil'],
            ['pt-PT', 'Portugal']
        ],
        ['Română',          ['ro-RO']],
        ['Slovenčina',      ['sk-SK']],
        ['Suomi',           ['fi-FI']],
        ['Svenska',         ['sv-SE']],
        ['Türkçe',          ['tr-TR']],
        ['български',       ['bg-BG']],
        ['Pусский',         ['ru-RU']],
        ['Српски',          ['sr-RS']],
        ['한국어',            ['ko-KR']],
        ['中文',
            ['cmn-Hans-CN', '普通话 (中国大陆)'],
            ['cmn-Hans-HK', '普通话 (香港)'],
            ['cmn-Hant-TW', '中文 (台灣)'],
            ['yue-Hant-HK', '粵語 (香港)']
        ],
        ['日本語',           ['ja-JP']],
        ['Lingua latīna',   ['la']]
    ],
    recognizing : false,
    link : null,
    field : null,
    results : null,

    checkSpeechRecognition : function checkSpeechRecognition ()
    {
        return ('webkitSpeechRecognition' in window);
    },

    getValue : function getValue()
    {
        let _t = VH.WebSpeech,
            s = '';
        if (_t.results === null) {
            return s;
        }

        for (let i = 0; i < _t.results.length; ++i) {
            s += _t.results[i][0].transcript;
        }
        _t.results = null;

        return s;
    },

    drawIcon : function drawIcon()
    {
        let _t = VH.WebSpeech,
            link = $('<a href="#" class="btn btn-circle btn-light">' + _t.iconOff + '</a>');

        _t.field.after(link);
        link.parent().css({'position' : 'relative'});
        link.css({'position':'absolute', 'top': 0/*f.position().top*/, 'right':0});
        link.on('click', function () {
            if (_t.recognizing) {
                _t.recognition.stop();
                _t.recognizing = false;
                _t.link.html(_t.iconOff);
            } else {
                _t.recognition.start();
            }
            return false;
        });
        return link;
    },

    init : function init(field)
    {
        let _t = VH.WebSpeech;

        if (!_t.checkSpeechRecognition()) {
            return false;
        }

        _t.field = ((typeof field) === 'string') ? $(field) : field;
        _t.link = _t.drawIcon(field);

        if (_t.recognition === null) {
            _t.recognition = new webkitSpeechRecognition();
            _t.recognition.continuous = true;
            _t.recognition.interimResults = false;
            _t.recognition.maxAlternatives = 1;
            _t.recognition.lang = 'ru-RU';

            _t.recognition.onstart = function() {
                _t.recognizing = true;
                _t.link.html(_t.iconOn);

                // showInfo('info_speak_now');
                // start_img.src = 'mic-animate.gif';
            };

            _t.recognition.onend = function() {
                if (_t.recognizing) {
                    _t.recognition.start();
                }
                // if (ignore_onend) {
                //     return;
                // }
                // start_img.src = 'mic.gif';
                // if (!final_transcript) {
                //     showInfo('info_start');
                //     return;
                // }
                // showInfo('');
                // if (window.getSelection) {
                //     window.getSelection().removeAllRanges();
                //     var range = document.createRange();
                //     range.selectNode(document.getElementById('final_span'));
                //     window.getSelection().addRange(range);
                // }
                // if (create_email) {
                //     create_email = false;
                //     createEmail();
                // }
            };
            _t.recognition.onresult = function(event) {
                console.log([_t.recognizing, event]);
                _t.results = event.results;
                if (!_t.recognizing) {
                    _t.field.val(_t.getValue());
                }
            };


            //
            // _t.recognition.onerror = function(event) {
            //     if (event.error === 'no-speech') {
            //         start_img.src = 'mic.gif';
            //         showInfo('info_no_speech');
            //         ignore_onend = true;
            //     }
            //     if (event.error === 'audio-capture') {
            //         start_img.src = 'mic.gif';
            //         showInfo('info_no_microphone');
            //         ignore_onend = true;
            //     }
            //     if (event.error === 'not-allowed') {
            //         if (event.timeStamp - start_timestamp < 100) {
            //             showInfo('info_blocked');
            //         } else {
            //             showInfo('info_denied');
            //         }
            //         ignore_onend = true;
            //     }
            // };
            //
            // _t.recognition.onend = function() {
            //     recognizing = false;
            //     if (ignore_onend) {
            //         return;
            //     }
            //     start_img.src = 'mic.gif';
            //     if (!final_transcript) {
            //         showInfo('info_start');
            //         return;
            //     }
            //     showInfo('');
            //     if (window.getSelection) {
            //         window.getSelection().removeAllRanges();
            //         var range = document.createRange();
            //         range.selectNode(document.getElementById('final_span'));
            //         window.getSelection().addRange(range);
            //     }
            //     if (create_email) {
            //         create_email = false;
            //         createEmail();
            //     }
            // };
            //
            // recognition.onresult = function(event) {
            //     var interim_transcript = '';
            //     for (var i = event.resultIndex; i < event.results.length; ++i) {
            //         if (event.results[i].isFinal) {
            //             final_transcript += event.results[i][0].transcript;
            //         } else {
            //             interim_transcript += event.results[i][0].transcript;
            //         }
            //     }
            //     final_transcript = capitalize(final_transcript);
            //     final_span.innerHTML = linebreak(final_transcript);
            //     interim_span.innerHTML = linebreak(interim_transcript);
            //     if (final_transcript || interim_transcript) {
            //         showButtons('inline-block');
            //     }
            // };
        }
    }
};